<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-5xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="w-full flex">
          <div class="w-2/12 flex flex-col text-left border-2 px-3 py-2">
            <div class="flex items-center" v-for="(color, index) in colors" :key="index">
              <span class="h-4 w-4" :style="{background : `#${color.color}`}"></span>
              <span class="pl-2">{{color.name}}</span>
            </div>
          </div>
          <div class="w-10/12 pl-2">
            <div class="flex items-center text-left pb-4">
              <div class="relative">
                <select
                  v-model="selectedView"
                  class="block appearance-none bg-gray-200 border border-gray-300 text-gray-700 py-2 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                >
                  <option
                    v-for="(options, index) in viewModeOptions"
                    :value="options.value"
                    :key="index"
                  >{{options.title}}</option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                >
                  <svg
                    class="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    />
                  </svg>
                </div>
              </div>
              <div class="flex items-center">
                <button
                  class="flex items-center bg-cdmx-green text-white rounded px-3 py-1 ml-2"
                  type="button"
                  @click="onClickNav('today')"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-current text-white h-4 w-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
                    />
                  </svg>
                  <span>Hoy</span>
                </button>
                <button
                  class="flex items-center justify-center bg-white text-gray-900 border-2 rounded px-2 py-1 ml-2"
                  type="button"
                  @click="onClickNav('prev')"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-current text-gray-900 h-5 w-5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                  </svg>
                </button>
                <button
                  class="flex items-center justify-center bg-white text-gray-900 border-2 rounded px-2 py-1 ml-1"
                  type="button"
                  @click="onClickNav('next')"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-current text-gray-900 h-5 w-5"
                    viewBox="0 0 24 24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                  </svg>
                </button>
              </div>
              <span class="font-bold text-xl tracking-wider ml-2 capitalize">{{dateRange}}</span>
            </div>
            <calendar
              ref="tuiCal"
              :schedules="events"
              :view="selectedView"
              :taskView="false"
              :isReadOnly="true"
              :month="month"
              :week="week"
              :template="template"
            />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { Calendar } from "@toast-ui/vue-calendar";
import "tui-calendar/dist/tui-calendar.css";
import moment from "moment";

const today = new Date();
const getDate = (type, start, value, operator) => {
  start = new Date(start);
  type = type.charAt(0).toUpperCase() + type.slice(1);
  if (operator === "+") {
    start[`set${type}`](start[`get${type}`]() + value);
  } else {
    start[`set${type}`](start[`get${type}`]() - value);
  }
  return start;
};

export default {
  name: "event-calendar",
  data() {
    return {
      viewModeOptions: [
        {
          title: "Mensual",
          value: "month"
        },
        {
          title: "Semanal",
          value: "week"
        },
        {
          title: "Diario",
          value: "day"
        }
      ],
      dateRange: "",
      selectedView: "month",
      month: {
        daynames: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
      },
      week: {
        daynames: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"]
      },
      template: {
        alldayTitle: function() {
          return '<span class="tui-full-calendar-left-content">Todo el día</span>';
        },
        monthGridHeaderExceed: function(hiddenSchedules) {
          return (
            '<span class="tui-full-calendar-weekday-grid-more-schedules">' +
            hiddenSchedules +
            " más</span>"
          );
        },
        timegridCurrentTime: function(timezone) {
          let currentDate = new Date(timezone.hourmarker);

          return moment(currentDate).format("hh:mm a");
        },
        popupDetailDate: function(isAllDay, start, end) {
          let startDate = new Date(start);
          let endDate = new Date(end);

          return (
            moment(startDate).format("DD/MM/YYYY hh:mm a") +
            " - " +
            moment(endDate).format("DD/MM/YYYY hh:mm a")
          );
        },
        popupDetailBody: function(schedule) {
          return `<div class="flex flex-col">
                    <div class="flex">
                      <span class="font-bold">Descripción:&nbsp;</span><span>${schedule.body}</span>
                    </div>
                    <div class="flex">
                      <span class="font-bold">Lugar:&nbsp;</span><span>${schedule.raw.place}</span>
                    </div>
                    <div class="flex items-center justify-center">
                      <img src="${schedule.raw.image}" />
                    </div>
                  </div>`;
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    events: {
      required: true
    },
    colors: {
      required: true
    }
  },
  components: {
    Calendar
  },
  watch: {
    showing(value) {
      if (value) {
        this.setRenderRangeText();
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    },
    selectedView(newValue) {
      this.$refs.tuiCal.invoke("changeView", newValue, true);
      this.setRenderRangeText();
    }
  },
  methods: {
    close() {
      this.$emit("close", "dismiss");
    },
    setRenderRangeText() {
      this.$nextTick(() => {
        const { invoke } = this.$refs.tuiCal;
        const view = invoke("getViewName");
        const calDate = invoke("getDate");
        const rangeStart = invoke("getDateRangeStart");
        const rangeEnd = invoke("getDateRangeEnd");
        let year = calDate.getFullYear();
        let month = calDate.getMonth() + 1;
        let date = calDate.getDate();
        let dateRangeText = "";
        let endYear, endMonth, endDate, start, end, startLabel, endLabel;
        switch (view) {
          case "month":
            dateRangeText = moment(`${year}-${month}`).format("MMMM YYYY");
            break;
          case "week":
            year = rangeStart.getFullYear();
            month = rangeStart.getMonth() + 1;
            date = rangeStart.getDate();
            endYear = rangeEnd.getFullYear();
            endMonth = rangeEnd.getMonth() + 1;
            endDate = rangeEnd.getDate();
            start = `${year}-${month}-${date}`;
            end = `${endYear}-${endMonth}-${endDate}`;
            if (year !== endYear) {
              startLabel = moment(start).format("DD MMMM YYYY");
              endLabel = moment(end).format("DD MMMM YYYY");
            } else {
              startLabel = moment(start).format("DD MMMM");
              endLabel = moment(end).format("DD MMMM YYYY");
            }
            dateRangeText = `${startLabel} ~ ${endLabel}`;
            break;
          default:
            dateRangeText = moment(`${year}-${month}-${date}`).format(
              "DD MMMM YYYY"
            );
        }
        this.dateRange = dateRangeText;
      });
    },
    onClickNav(type) {
      this.$refs.tuiCal.invoke(type);
      this.setRenderRangeText();
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
